export const RUNTIME_FAILURE_KEY = 'sb-runtime-failure';

export function sanitizeFailureText(value) {
  return String(value ?? '')
    .replace(/Bearer\s+[A-Za-z0-9._~+/=-]+/gi, 'Bearer [redacted]')
    .replace(/eyJ[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/g, '[redacted]')
    .replace(/((?:token|secret|password|authorization|api[_-]?key)=)[^&\s]+/gi, '$1[redacted]')
    .slice(0, 1500);
}

export function recordRuntimeFailure(error, errorInfo, storage = sessionStorage) {
  const bytes = new Uint8Array(4);
  if (globalThis.crypto?.getRandomValues) globalThis.crypto.getRandomValues(bytes);
  const reference = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  const record = {
    reference,
    name: sanitizeFailureText(error?.name || 'Error').slice(0, 80),
    message: sanitizeFailureText(error?.message || error).slice(0, 300),
    componentStack: sanitizeFailureText(errorInfo?.componentStack || ''),
    at: new Date().toISOString(),
  };
  try {
    storage?.setItem?.(RUNTIME_FAILURE_KEY, JSON.stringify(record));
  } catch (_) {
    // The screen still shows the reference when storage is blocked.
  }
  return record;
}
